import { defineStore } from 'pinia';
import i18n from '#layers/core/shared/i18n';

export const useSettingsStore = defineStore('plugin:settings', () =>
{
    function $settings(name: string, throwError: boolean = false)
    {
        return new Promise((resolve, reject) =>
        {
            const config: any = { ...i18n };

            resolve(config[name] || {});
        });
    }

    return { $settings };
});
